module.exports = new __parcel__URL__("soleil-nuage-2-pluie-2.8591b68a.svg").toString();